import { visitRef } from './visitRef.js';
export const collectRef = (json) => {
    const refs = [];
    visitRef(json, _ => refs.push(_));
    return refs;
};
